/**
 * The pause between readiness attempts. It lives in its own module so tests
 * can `vi.mock` it down to a few milliseconds: setTimeout can't be faked in
 * browser tests (TanStack Query batches its notifications on it), and a real
 * second per attempt adds up across polling tests.
 */
export const POLLING_DELAY_MS = 1000;
